import React from 'react';

import { CalendarSourceStatus } from '../../../data/entities/calendar-source';
import { Paragraph } from '../paragraph/Paragraph';
import { getSourceStatusMessage } from './helpers';

interface ICalendarSourceUrlStatusProps {
	sourceState?: CalendarSourceStatus;
}

export const CalendarSourceUrlStatus: React.FC<ICalendarSourceUrlStatusProps> = ({ sourceState }) => {

	return <div className="calendar-source-status__container">
		<div className="calendar-source-status__icon">
			<img src={`/92b3b47/assets/icons/messages/${sourceState}.svg`}></img>
		</div>
		<div className={`calendar-source-status__description calendar-source-status__description-${sourceState}`}>
			<Paragraph>{getSourceStatusMessage(sourceState)}</Paragraph>
		</div>
	</div>;
};
